import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router';

import { NavigationPanel } from 'widgets/NavigationPanel';
import { PageLoader } from 'widgets/PageLoader';

import { getCurrentUser } from 'entities/User/lib/utils/getCurrentUser';

import { classNames } from 'shared/lib/utils/classNames';

import cls from './LayoutDefault.module.scss';

export function LayoutDefault() {
  const currentUser = getCurrentUser();
  const location = useLocation();

  return (
    <div className={cls.LayoutDefault}>
      <div className={classNames(cls.SlotNavigation)}>
        {currentUser && <NavigationPanel currentUser={currentUser} />}
      </div>

      <div className={classNames(cls.SlotPage)} key={location.pathname}>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
}
